module.exports = __webpack_public_path__ + "static/banner-oh-a4ccad6381dd1a2cef1076019979a421.jpg";